// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"65":"b8c0037b72cbb37c","486":"753fffae62cf6001","565":"6a0ff455b466291b","867":"c82c32f758a5c1aa"}[chunkId] + ".js";
};